const BASE_URL = '/'

export { BASE_URL }
